import { render } from "./ProductItemList_Activity.vue?vue&type=template&id=43e0ffce&ts=true"
import script from "./ProductItemList_Activity.vue?vue&type=script&lang=ts"
export * from "./ProductItemList_Activity.vue?vue&type=script&lang=ts"

import "./ProductItemList_Activity.vue?vue&type=style&index=0&id=43e0ffce&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__